import React from 'react';
import Header from '../components/Header';
import CareersBanner from '../components/careers/CareersBanner';
import CareersIntro from '../components/careers/CareersIntro';
import WhyWorkWithUs from '../components/careers/WhyWorkWithUs';
import Opportunities from '../components/careers/Opportunities';
import JoinUsCTA from '../components/careers/JoinUsCTA';

const Careers = () => {
	return (
		<div className="min-h-screen bg-white">
			<Header />
			<CareersBanner />
			<CareersIntro />
			<WhyWorkWithUs />
			<Opportunities />
			<JoinUsCTA />
			
		</div>
	);
};

export default Careers;


